'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const defaultDOMRect = {
  height: 0,
  width: 0,
  x: 0,
  y: 0,
  bottom: 0,
  left: 0,
  right: 0,
  top: 0,
  toJSON: () => {
  }
};
const useDimensions = () => {
  const ref = React.useRef(null);
  const [dimensions, setDimensions] = React.useState(defaultDOMRect);
  React.useEffect(() => {
    const rect = ref && ref.current ? ref.current.getBoundingClientRect() : defaultDOMRect;
    setDimensions(rect);
  }, []);
  return [ref, dimensions];
};

exports.useDimensions = useDimensions;
//# sourceMappingURL=useDimensions.cjs.js.map
